var exports = {
  "l": "signedOutBanner__k-kNxi",
};

module.exports = exports;
